import React from "react";
import NavBar from "./NavBar";

const Header = () => {
  return (
    <>
      <div className="header p-0">
        <NavBar />
      </div>
    </>
  );
};

export default Header;
